// function productcarousel(){
//   var productslider=[];
//   document.querySelectorAll('.product-carousel').forEach(function(Element,index){
//     let productid = Element.dataset.id;
//     let outer_carousel = Element.closest('.carousel-rowouter');
//     let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
//     let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
//     let swiperObject={
//       loop:eval(Element.dataset.loop),
//       slidesPerView: "auto",
//       navigation: {
//         nextEl:nextbutton,
//         prevEl:prevbutton,
//       },
//     };    
//     productslider[productid]=new Swiper(Element,swiperObject);
//   });
// }
// productcarousel();



function productcarousel(){
  var productslider=[];
  document.querySelectorAll('.product-carousel').forEach(function(Element,index){
    let productid = Element.dataset.id;
    let outer_carousel = Element.closest('.carousel-rowouter');
    // let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
    // let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
    let swiperObject={
      loop:eval(Element.dataset.loop),
      slidesPerView: 4.1,
      spaceBetween: 20,
      breakpoints: {
        0: {
          slidesPerView: 1.9,
          spaceBetween: 5,
        },
        576: {
          slidesPerView: 2.5,
          spaceBetween: 5,
        },
        768: {
          slidesPerView: 3.5,
          spaceBetween: 10,
        },
        992: {
          slidesPerView: 4.1,
          spaceBetween: 20,
        }
      },
      mousewheel: {
        releaseOnEdges: true,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
      }
    };    
    productslider[productid]=new Swiper(Element,swiperObject);
  });
}
productcarousel();















